
<template>
  <div id="app">
    <v-container grid-list-xl id="main"> 
      <v-layout align-start justify-start row fill-height wrap>
          <!-- navigation-->
          <v-flex md2>
              <SiteNav/>
          </v-flex>
          <!-- content -->
          <v-flex md9 id="content-box">
            <router-view/>
          </v-flex>
          <v-flex md12>
            <footer>
              Made with Vue. &copy; Daniel Devine 2019.
            </footer>
          </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style>
  footer{
    font-size: 9pt;
    text-align: center;
    position: fixed;
    bottom: 0;
  }

  body {
    background: linear-gradient(0deg, rgba(0, 175, 231, 0.75), rgba(0, 175, 231, 0.75)), url(./assets/selfie_cutout_grey_flipped_shrunk.png);
    background-size: auto 100%;
    background-position: bottom right;
    background-repeat: no-repeat;
    background-attachment: fixed;
    @import url('https://fonts.googleapis.com/css?family=Lora');
    font-family: "Lora", Times, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .title-rule {
    border-bottom: 1px solid #FFFFFF;
    text-align: center;
    padding: 0px;
  }

  .subtitle-black {
    color: #000000;
    text-align: center;
    font-size: 28pt;
    font-weight: bold;
    margin-top: 10px;
  }
  
  #main {
    /* This is to take the automatic margins out of the main container */
    margin: 0px;
  }
  
  #content-box p {
    @import url('https://fonts.googleapis.com/css?family=Lora');
    font-family: "Lora", Times, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;
  }

  #content-box p.punchy {
    color: #FFFFFF;
    font-weight: bold;
  }

  #content-box a.punchylink:link {
    color: #FFFFFF;
    font-weight: bold;
    text-decoration: none;
  }
  
  #content-box a.punchylink:visited {
    color: #FFFFFF;
    font-weight: bold;
    text-decoration: none;
  }

  #app h1.title {
    @import url('https://fonts.googleapis.com/css?family=Lora');
    font-family: "Lora", Times, serif;
    font-weight: bold;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #FFFFFF;
    font-size: 60pt;
    margin-block-end: 0px;
  }

  #app h1.heading {
    @import url('https://fonts.googleapis.com/css?family=Lora');
    font-family: "Lora", Times, serif;
    font-weight: bold;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #FFFFFF;
    font-size: 35pt;
    margin-block-end: 0px;
  }

  /* Bolded list items. */
  #content-box ul.tiered li {
    font-weight: bold;
    margin-top: 10px;
  }

  /* Don't bold sub-lists */
  #content-box ul.tiered li ul li {
    font-weight: normal;
  }

  @media only screen and (max-width: 600px) {
    #app h1  {
      font-size: 28pt;
    }
  }

  #nav li > * {
    @import url('https://fonts.googleapis.com/css?family=Lora');
    font-family: "Lora", Times, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 18pt;
    font-weight: bold;
    color: #FFFFFF;
  }
  
  #nav > li > a {
    text-decoration: none;
  }

  #nav > li > a:hover {
    color: #DDDDDD;
  }

  #nav {
    padding: 150px 10px 0px 0px;
    list-style: none;
  }
</style>


<script>
  import SiteNav from './SiteNav.vue';

  export default {
    name: 'App',
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Home',
      // all titles will be injected into this template
      titleTemplate: '%s | DDEVnet.net'
    },
    components: {
      SiteNav,
    }
  }
</script>